import React, { Component } from 'react'
import { isSet } from '../../utils/commonUtils'
import FormInputs from '../../components/UI/FormInputs';
import IncidentService from '../../services/IncidentService';
import ReferralProviderService from '../../services/ReferralProviderService';
import EmrVisitsService from '../../services/EmrVisitsService';

export default class RestrictionsReferrals extends Component {
           constructor(props) {
                super(props);
                // Initialize state 
                this.state = {
                    activeTab:"1",
                    specialityList: [],
                    referralProviderOptions: [],
                }
                this.fieldRefs = {}
    }
    componentDidMount() {
        this.fetchSpecialityList();
        this.fetchReferralProviders();
        setTimeout(() => {
            this.syncEmrReferralsToFormData();
        }, 1000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visitId !== this.props.visitId) {
            setTimeout(() => {
                this.syncEmrReferralsToFormData();
            }, 1000);
        }
         if (prevProps.validations !== this.props.validations && Object.keys(this.props.validations).length > 0) {
          this.props.handleErrorFocus(this.getInputFieldsTab2(), this.fieldRefs);
        }
    }
    fetchReferralProviders = async () => {
        try {
            const response = await ReferralProviderService.getReferralProviders(null, {
                perPage: 1000, // Get all providers
                page: 1
            });
                        
            if (response && response.data && Array.isArray(response.data)) {
                const options = response.data.map((provider) => ({
                    label: `${provider.first_name || ''} ${provider.last_name || ''}${provider.specialty ? ` (${provider.specialty})` : ''}`.trim(),
                    value: provider.referral_provider_id,
                    name: `${provider.first_name || ''} ${provider.last_name || ''}`.trim(),
                    data: provider,
                }));
                this.setState({ referralProviderOptions: options });
            } else {
                console.warn('Unexpected response structure from referral-provider API:', response);
            }
        } catch (error) {
            console.error('Error fetching Referral Providers:', error);
            this.setState({ referralProviderOptions: [] });
        }
    }
    fetchSpecialityList = async () => {
        try {
            const response = await IncidentService.getLookUpList('Speciality for referrals');
            if (response && Array.isArray(response)) {
                const sorted = response.sort((a, b) => {
                    const posA = a.display_position || 0;
                    const posB = b.display_position || 0;
                    return posA - posB;
                });
                this.setState({ specialityList: sorted });
            }
        } catch (error) {
            console.error('Error fetching Speciality lookup:', error);
        }
    }

    syncEmrReferralsToFormData = async () => {
        const { visitId, formData, onChangeHandler } = this.props;
        if (!visitId || !onChangeHandler) return;

        if (this._syncing) {
            return;
        }
        this._syncing = true;

        try {
            const { specialityList } = this.state;
            if (!specialityList || specialityList.length === 0) {
                this._syncing = false;
                return;
            }
            const emrResponse = await EmrVisitsService.getReferralSelection(visitId).catch(() => ({ data: [] }));
            const emrReferralData = emrResponse?.data || [];
            if (emrReferralData.length === 0) {
                this._syncing = false;
                return;
            }
            let hasChanges = false;

            emrReferralData.forEach((emrReferral) => {
                const specialityName = emrReferral.speciality_name;
                if (!specialityName || !emrReferral.referral_provider_id) return;

                const specialityItem = specialityList.find(
                    item => (item.value || item.label) === specialityName
                );

                if (specialityItem) {
                    const fieldName = this.getFieldName(specialityItem.value || specialityItem.label);
                    const referralFieldName = `${fieldName}_referral`;

                    const currentCheckboxValue = formData[fieldName];
                    const currentReferralValue = formData[referralFieldName];

                    if (!currentCheckboxValue || currentCheckboxValue == 0 || currentCheckboxValue == "0") {
                        onChangeHandler(fieldName, "1");
                        onChangeHandler(referralFieldName, emrReferral.referral_provider_id);
                        hasChanges = true;
                    } else if (currentReferralValue !== emrReferral.referral_provider_id) {
                        onChangeHandler(referralFieldName, emrReferral.referral_provider_id);
                        hasChanges = true;
                    }
                }
            });

            if (hasChanges) {
                console.log('Synced EMR referrals to incident formData');
            }
        } catch (error) {
            console.error('Error syncing EMR referrals to formData:', error);
        } finally {
            this._syncing = false;
        }
    }
    // Helper function to convert label to field name (e.g., "Physical Therapy" -> "physical_therapy")
    // Must match the field names in the database migration
    getFieldName = (label) => {
        return label.toLowerCase()
            .replace(/\//g, '_')    // Replace / with underscore first
            .replace(/\(/g, '')     // Remove opening parenthesis
            .replace(/\)/g, '')     // Remove closing parenthesis
            .replace(/&/g, '')      // Remove & (don't replace with 'and')
            .replace(/,/g, '')      // Remove commas
            .replace(/-/g, '_')     // Replace hyphens with underscores
            .replace(/\s+/g, '_')   // Replace spaces with underscores
            .replace(/[^a-z0-9_]/g, '') // Remove any remaining special characters
            .replace(/_+/g, '_')    // Replace multiple underscores with single
            .replace(/^_|_$/g, ''); // Remove leading/trailing underscores
    }
    getReferralFields = () => {
        const { specialityList } = this.state;
        const referralFields = [];
        
        if (specialityList && specialityList.length > 0) {
            specialityList.forEach((item) => {
                const label = item.value || item.label || '';
                const fieldName = this.getFieldName(label);
                
                referralFields.push({
                    type: "Checkbox",
                    isLabelAppend: true,
                    label: label,
                    placeholder: "",
                    className: "form-check-input",
                    name: fieldName,
                    col: 'col-6',
                    isAppend: true,
                });
                
                referralFields.push({
                    type: "SelectSearchList",
                    label: "Referral",
                    placeholder: "",
                    className: "form-control form-control-solid",
                    name: `${fieldName}_referral`,
                    isShow: true,
                    col: 'col-6',
                    options: this.state.referralProviderOptions,
                    required: isSet(this.props.formData[fieldName], '') == 1 ? true : false,
                    isAppend: true,
                    readOnly: isSet(this.props.formData[fieldName], '') == 1 ? false : true,
                });
            });
        }
        
        return referralFields;
    }
    handlechange=(name, value, e,type)=>{            
      // if (type === 'CheckboxDropDown') {
      //   let newArray = this.props.formData[name]
      //     ?  this.props.formData[name].split(",").filter((item) => item) // convert to array
      //     : [];

      //   if (e || e===true) {
      //     if (!newArray.includes(value)) {
      //       newArray.push(value);
      //     }
      //   } else {
      //     newArray = newArray.filter((item) => item !== value);
      //   }
      //   value = newArray.join(",");
      // }
      this.props.onChangeHandler(name, value, e)
    }
  render() {
    const {validations,formData,onChangeHandler}=this.props
    
    const inputFields=this.getInputFieldsTab2()
    return (
      <>
      {inputFields.map((section, secIndex) => {
                return (
                    <div className="card mb-2" key={secIndex}>
                        <a href={`#collapseCardExample_${secIndex}`} className="d-block sh_accordionheader card-header" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="collapseCardExample" style={{ position: 'sticky', top: '-20px', zIndex: '1' }}>
                            <h6 className="mb-0 text-md">{section.title}</h6>
                        </a>
                        <div className="collapse show" id={`collapseCardExample_${secIndex}`} data-bs-parent="#modal111">
                            <div className="card-body">
                                <div className="row">
                                    {section.data.map((item, itemIndex) => {
                                      
                                      if (isSet(item.isShow, true) === false) { return false }
                                        const value = isSet(formData[item.name],'');
                                        return (
                                            <div className={isSet(item.isAppend, false) === true ?"col-sm-6":"col-sm-12"} key={itemIndex}>
                                            <div className="form-group row">
                                              <label className={isSet(item.isAppend, false) === true ?"col-sm-6 col-form-label opacity-75 ":"col-sm-3 col-form-label opacity-75"}>{item.label}</label>
                                              <div className={isSet(item.isAppend, false) === true ?"col-sm-5":"col-sm-9"}>
                                                {isSet(item.isLabelAppend, false) === true ?
                                                  <div className="form-check">
                                                    <FormInputs {...item} value={value} changeHandler={(val, e) => { onChangeHandler(item.name, val, e) }} />
                                                    {(isSet(validations[item.name], '') !== '' ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : '')}
                                                  </div>
                                                  : <>
                                                    <FormInputs {...item} value={value} changeHandler={(val,e) => { this.handlechange(item.name, val,e,item.type) }} />
                                                    {(isSet(validations[item.name], '') !== '' ? <span className="text-danger m-1">{isSet(validations[item.name], '')}</span> : '')}
                                                  </>}
                                              </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        
    </>
    )
  }
  getInputFieldsTab2 = () => {
    return [
      {
        title: 'Incident / Injury Details',
        data: [
          {
            type: "SelectSearchList",
            label: "Assigned Primary Physician",
            placeholder: "Assigned Primary Physician",
            className: "form-control form-control-solid",
            name: "assigned_primary_physician",
            col: 'col-6',
            options:this.props.providerOptions,
          },
           {
            type: "SelectSearchList",
            label: "Other Treating Provider",
            placeholder: "Other Treating Provider",
            className: "form-control form-control-solid",
            name: "other_treatment_provider",
            col: 'col-6',
            options:this.props.providerOptions,
            
          },
            {
            type: "SelectList",
            label: "Incident Type",
            placeholder: "Incident Type",
            className: "form-control form-control-solid",
            name: "incident_type",
            col: 'col-6',
            options:[{
              label:"Injury",
              value:"Injury",
            },
            {
              label:"Exposure",
              value:"Exposure",
            },
            {
              label:"Illness",
              value:"Illness"
            },
          ],
          },
            {
            type: "SelectList",
            label: "Recordable or First Aid",
            placeholder: "Recordable or First Aid",
            className: "form-control form-control-solid",
            name: "recordable_or_first_aid",
            col: 'col-6',
            options:this.props.LookupList["recordable_or_first_aid"],
          },
        ]
      },
      {
        title: 'Referrals',
        data: this.getReferralFields(),
      },
      {
        title: 'Work Restrictions',
        data: [
          {
            type: "Date",
            label: "Restirctions Start Date",
            placeholder: "Restirctions Start Date",
            className: "form-control form-control-solid",
            name: "restrictions_start_date",
            col: 'col-6',
          },
          {
            type: "Date",
            label: "End Date or Continued",
            placeholder: "End Date or Continued",
            className: "form-control form-control-solid",
            name: "restrictions_end_date_or_continued",
            col: 'col-6',
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Weight Bearing",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "weight_bearing",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_weight_bearing"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Lifting / Carrying",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "lifting_carrying",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_lifting_carrying"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Sitting / Standing",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "sitting_standing",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_sitting_standing"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Standing Duration",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "standing_duration",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_standing_duration"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Walking Distance",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "walking_distance",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_walking_distance"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Pushing / Pulling",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "pushing_pulling",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_pushing_pulling"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Breaks",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "work_restriction_breaks",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_breaks"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Max Shift Length",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "max_shift_length",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_max_shift_length"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Equipment Use",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "equipment_use",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_equipment_use"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Overhead Reaching",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "overhead_reaching",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_overhead_reaching"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Repetitive Grasping",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "repetitive_grasping",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_repetitive_grasping"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Climbing (stairs / ladders)",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "climbing_stairs_ladders",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_climbing_stairs_ladders"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Squatting / Kneeling",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "squatting_kneeling",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_squatting_kneeling"]
          },
          {
           type: "SelectSearchList",
            isMulti: true,
            label: "Bending (back)",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "work_restriction_bending_back",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_bending_back"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Twisting (spine)",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "work_restriction_spine",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_spine"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "DME Use",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "dme_use",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_dme_use"]
          },
          {
            type: "SelectSearchList",
            isMulti: true,
            label: "Environmental Exposures",
            placeholder: "",
            className: "form-control form-control-solid",
            name: "environmental_exposures",
            col: 'col-6',
            options: this.props.LookupList["work_restriction_environmental_exposures"]
          }


        ]
      },
    ]
  }
}
